// stores/themeStore.js
import {
	defineStore
} from 'pinia';

export const useThemeStore = defineStore('theme', {
	state: () => ({
		// 当前主题: 'light' 或 'dark'
		currentTheme: 'dark',
		// 主题配置
		themes: {
			light: {
				name: '亮色主题',
				variables: {
					'--primary-color': '#1890ff',
					'--primary-color-light': '#40a9ff',
					'--primary-color-dark': '#096dd9',
					'--secondary-color': '#52c41a',
					'--secondary-color-light': '#73d13d',
					'--secondary-color-dark': '#389e0d',
					'--background-color': '#ffffff',
					'--surface-color': '#fafafa',
					'--text-color': '#333333',
					'--text-color-secondary': '#666666',
					'--border-color': '#d9d9d9',
					'--box-shadow': '0 2px 8px rgba(0, 0, 0, 0.1)',
					'--border-radius': '4px',
				}
			},
			dark: {
				name: '暗色主题',
				variables: {
					'--menu-width':'9.6vw',
					'--menuNone':'block',
					'--minWidth':'160px',
					'--background-color': '#0C131D',
					'--box-color': '#112A49',
					'--mainBoxBack':'linear-gradient(0deg, rgba(17, 42, 73, 0.8) 0%, #112A49 100%)',
					'--mainBoxBorder':'rgba(24, 100, 170, 0.3)',
					'--textSelect-color': '#00FFF7',
					'--textSelectHover': 'rgba(101, 185, 237, 0.2)',
					'--text-color': '#22AAFF',
					'--textTable-color': '#FFFFFF',
					'--border-color': '#434343',
					'--tree-color':'#65B9ED',
					'--treeTitle':'#fff',
					'--treeTitleBottom':'#1864AA',
					'--inputBorder':'#2062B2',
					'--InputCenter':'#0F2239',
					'--tableTitle':'#F3F3F3',
					'--tableRowN':'#123255',
					'--tableRow2N':'#113C67',
					'--treeBorder':'#1864AA',
					'--checked':'#00A49F',
					'--noChecked':'#0C111B',
					'--noCheckedBorder':'#1864AA',
					'--failTag':'#FF3133 ',
					'--failTagBackground':'rgba(255, 49, 51, 0.3)',
					'--sucTag':'#00ED68 ',
					'--sucTagBackground':'rgba(0, 237, 104, 0.3)',
					'--offTag':'#CBCBCB ',
					'--offTagBackground':'rgba(203, 203, 203, 0.3)',
					'--updateTag':'#00FFF7 ',
					'--updateTagBackground':'rgba(0, 255, 247, 0.3)',
					'--commonTag':'#FFE500',
					'--commonTagBack':'rgba(255, 229, 0, 0.3)',
					'--largerTag':'#FF8400',
					'--largerTagBack':'rgba(255, 132, 0, 0.3)',
					'--pageBackground':'#0C111B',
					'--pageBorder':'#2062B2',
					'--pageTitle':'#fff',
					'--formTitle':'#fff',
					'--formTable':'#65B9ED',
					'--inputNumberBorder':'#236CB2',
					'--btnBack':'rgba(12, 17, 27, 0.5)',
					'--btnBorder':'linear-gradient(0deg, #1D75BC 0%, rgba(32, 98, 178, 0.4) 100%)',
					'--btnBorder1':'rgba(32, 98, 178, 0.5)',
					'--btnPBack':'#026fa1',
					'--btnPBorder':'linear-gradient(0deg, rgba(79, 217, 255, 0.8) 0%, rgba(79, 217, 255, 0.5) 100%)',
					'--btnErrBack':'#D62A2C',
					'--btnErrBorder':'linear-gradient(0deg, #FF5A5C 0%, rgba(255, 90, 92, 0.23) 97%)',
					'--btnDownBack':'rgba(12, 17, 27, 0.5)',
					'--btnDownBorder':'linear-gradient(0deg, #1D75BC 0%, rgba(32, 98, 178, 0.4) 100%) ',
					'--drawerHeaderBack':'linear-gradient(0deg, #1F4779 0%, rgba(24, 57, 97, 0) 100%)',
					'--drawerHeaderTitle':'#00FFF7',
					'--diasbledBack':'rgba(12, 17, 27, 0.3)',
					'--diasbledBorder':'rgba(35, 108, 178, 0.5)',
					'--dropBack':'#113B66',
					'--workViewBack':'linear-gradient(180deg, #074781 0%, #002343 100%)',
					'--workViewCard':'rgba(17, 72, 123, 0.5)',
					'--workViewCardBorder':'rgba(24, 100, 170, 0.7)',
					'--groupBack':'rgba(0, 255, 247, 0.15)',
					// '--el-input-text-color':'#fff',
					// '--el-messagebox-title-color':'#00FFF7',
					// '--el-messagebox-color':'#FF3338',
					
				},
			}
		}
	}),
	getters: {
		// 获取当前主题配置
		currentThemeConfig(state) {
			return state.themes[state.currentTheme];
		},

		// 判断是否是暗色模式
		isDarkMode(state) {
			return state.currentTheme === 'dark';
		},

		// 获取主题名称
		themeName(state) {
			return state.themes[state.currentTheme].name;
		}
	},

	actions: {
		// 切换主题
		toggleTheme() {
			this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
			this.applyTheme();
			this.saveToStorage();
		},

		// 设置特定主题
		setTheme(theme) {
			if (this.themes[theme]) {
				this.currentTheme = theme;
				this.applyTheme();
				this.saveToStorage();
			}
		},

		// 应用主题到页面
		applyTheme() {
			const theme = this.themes[this.currentTheme];
			const root = document.documentElement;

			// 应用所有CSS变量
			Object.entries(theme.variables).forEach(([key, value]) => {
				root.style.setProperty(key, value);
			});

			// 设置主题类名
			if (this.currentTheme === 'dark') {
				root.classList.add('theme-dark');
				root.classList.remove('theme-light');
			} else {
				root.classList.add('theme-light');
				root.classList.remove('theme-dark');
			}

			// 触发主题变化事件
			this.emitThemeChange();
		},

		// 触发主题变化事件
		emitThemeChange() {
			window.dispatchEvent(new CustomEvent('theme-change', {
				detail: {
					theme: this.currentTheme,
					themeName: this.themeName
				}
			}));
		},

		// 保存到本地存储
		saveToStorage() {
			localStorage.setItem('app-theme', this.currentTheme);
		},

		// 从本地存储加载
		loadFromStorage() {
			const savedTheme = localStorage.getItem('app-theme');
			if (savedTheme && this.themes[savedTheme]) {
				this.currentTheme = savedTheme;
			}
		},

		// 初始化主题
		initialize() {
			// 从存储加载
			this.loadFromStorage();

			// 应用主题
			this.applyTheme();

			return this.currentTheme;
		},

		// 获取CSS变量值
		getVariable(name) {
			return this.themes[this.currentTheme].variables[name];
		}
	}
});

export default useThemeStore;